// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "487aec38119f5482d0d260a75b04b47a" + ".js";
};